module.exports = __webpack_public_path__ + "img/horizontal_4_1_7005.51d28376.png";